/**
 * Mirrors the backend `CategoryType` enum surfaced on the package status response
 * via `PackageStatusDetail.CategoryTypeCode`. Used to disambiguate the reason a
 * package is CANCELLED so polling clients can navigate to the appropriate page
 * even when the matching SignalR event is missed or arrives later.
 */
export enum PackageStatusCategory {
  KbaFail = 'KbaFail',
  MfaFail = 'MfaFail',
  PinFail = 'PinFail',
}
